export const FEATURE_FLAGS = {
  STANDALONE_API: 'StandaloneAPI',
}

export const WONDE_IDS = {
  IVANHOE_GRAMMAR: 'A1239809402',
}
